<template>
    <section v-if="data && ( (loadingPostsStatus === 'success' && postItems.length) || loadingPostsStatus === 'loading' )" class="module-posts margin-both-xl">
        <div class="container">
            <div class="heading-mod margin-bottom-sm">
                <h2 class="titler jost jost--35  text-center font--700">{{data.title || 'Opplevelser'}}</h2>
            </div>
            <PostsGrid v-if="loadingPostsStatus === 'success' && postItems && postItems.length" :posts="postItems" />
            <div class="module-link margin-top-sm text-center">
                <Button :hasIcon="false" :type="buttonColor" link :outlined="false">
                    <router-link   v-if="archiveLinkShow" :to="archiveInfo.link"><span class="txt font--600 jost--22">{{archiveInfo.text}}</span></router-link>
                </Button>
            </div>
        </div>
    </section>
</template>

<script>
import DummyLine from '@/components/elements/DummyLine'
import PostsGrid from '@/components/parts/PostsGrid'
import Button from '@/components/elements/Button'

import { mapOrder } from '@/helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'venue-module',
    props: ['data'],
    data(){
        return {
            archiveLinkShow: true,
            postType : (this.data && (this.data.type || this.data.show_type)) ? this.data.type || this.data.show_type : 'venu',
            postItems: [],
            loadingPostsStatus: 'loading',
        }
    },
    components:{
        DummyLine,
        PostsGrid,
        Button,
    },
    mounted(){
        const VM = this;
        if(!VM.data) return false;

        if(VM.includePosts){
            VM.loadPosts({
                type: VM.postType || 'post',
                include: VM.includePosts,
                exclude: VM.exclude,
                limit : VM.data.limit || 3,
            }).then(e=>{
                //load rest of posts
                if(e === 'success' && VM.postItems.length < 3){
                    VM.loadPosts({
                        type: VM.postType || 'post',
                        exclude: [...VM.exclude, ...VM.includePosts],
                        limit : 3 - VM.postItems.length,
                    })
                }
            })
        }else{
            VM.loadPosts()
        }
    },
    computed:{
        ...mapGetters([
            'currentPageID'
        ]),
        taxonomy(){
            let taxonomy = 'category'
            return taxonomy
        },
        includePosts(){
            return this.data.select_post || 0
        },
        archiveInfo(){
            let text = 'Se alle opplevelser'
            let link = '/opplevelser'
            return {link, text}
        },
        buttonColor(){
            let color = 'green'
            return color
        },
        loadOpt(){
            const VM = this;
            if(!VM.data) return [];
            const opt = {
                type: VM.postType || 'post',
                include: VM.includePosts,
                exclude: VM.data.exclude || 0,
                limit : VM.data.limit || 3,
            }
            return opt;
        },
        exclude(){
            let exclude = 0;
            if(this.currentPageID){
                exclude = [this.currentPageID]
            }
            if(this.data.exclude){
                exclude = [...exclude, ...this.data.exclude]
            }
            return exclude
        }
    },

    methods:{
		...mapActions([
			'getPost',
        ]),
        loadPosts(options){
            if(!options){
                options = this.loadOpt
            }
            const VM = this;
            VM.loadingPostsStatus = 'loading'
            return VM.getPost(options).then(res=>{
                if(res.data && res.data.posts && res.data.posts.length){

                    if(VM.includePosts){
                        VM.postItems.push(...mapOrder(res.data.posts, VM.includePosts, 'id'))
                    }else{
                        VM.postItems.push(...res.data.posts)
                    }
                }
                
                VM.loadingPostsStatus = 'success'
                return VM.loadingPostsStatus;
            })
        }
    }
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.module-posts{
    .posts-line{
        margin-bottom: -50px;
        @include mquery($tablet){
            margin-bottom: -30px;
        }
        @include mquery($phone){
            margin-bottom: -15px;
        }
    }
    .titler{
        margin: 0;
    }
    .module-link{
        .txt{
            text-transform: uppercase;
        }
    }
}

</style>